export const resumeData = {
    name: "Rushikesh Chavan",
    role: "Full-Stack Developer",
    contact: {
        phone: "7338435576",
        email: "rushic.dev@gmail.com",
        linkedin: "https://linkedin.com/in/rushikc",
        medium: "https://medium.com/@rushikc",
        github: "https://github.com/rushikc",
    },
    summary: "Results driven Full-Stack Developer with 6+ years of experience in architecting and delivering high-performance, scalable applications across the SDLC. Proficient in React, TypeScript, Java Spring Boot, Python, Relational/NoSQL databases, and cloud infrastructure (AWS, GCP) with Infrastructure as Code (Terraform). Specializes in crafting efficient, secure, and user-centric solutions.",
    skills: {
        languages: ["Java", "TypeScript", "Python", "JavaScript", "SQL", "Shell Scripting"],
        frontend: ["ReactJS", "HTML", "CSS", "RESTful APIs", "Micro-frontend", "UI/UX", "Accessibility (WCAG)"],
        backend: ["Java Spring Boot", "Microservices", "Event-Driven Architecture", "Serverless Computing"],
        databases: ["DynamoDB", "Oracle", "Postgres DB", "Firestore", "GraphQL"],
        cloud: ["AWS", "GCP", "Firebase"],
        aws: ["AppSync", "Apache Kafka", "ECS", "SQS", "Lambda", "DynamoDB", "S3", "Aurora", "Glue", "EKS", "IAM", "CloudWatch"],
        devops: ["Terraform", "CI/CD", "Jenkins", "Kubernetes", "Docker"],
        tools: ["Git", "Playwright", "Agile", "Jest", "Junit", "Selenium"],
    },
    experience: [
        {
            company: "Warner Bros. Discovery",
            role: "Senior Software Engineer",
            project: "InFlow",
            duration: "Nov 2025 – Present",
            location: "Bengaluru · Hybrid",
            description: "Live streaming, Live programming, Scheduling, On-demand video & Metadata generation",
            points: [
                "Live team - responsible for building the robust, scalable ecosystem that powers WBD's live streaming & programming around the world.",
                "Working on Systems responsible for Live streaming program generation, Electronic program guide, Program video editing/trimming, ad insertion, Key moments insertion, Editorials and metadata generation for HBO Max & Discovery+ front-end & player clients."
            ]
        },
        {
            company: "J.P. Morgan",
            role: "Full-time",
            project: "TimeX",
            duration: "Nov 2023 – Oct 2025",
            location: "Bengaluru",
            description: "Handles US Employee time & absence along with payroll reports & automations",
            points: [
                "Led the design and implementation of multi-region, resilient, and event-driven serverless architectures (AWS ECS, SQS, Lambda, DynamoDB, S3) and provisioned associated infrastructure using Terraform, ensuring scalability and high availability.",
                "Created SQS-driven lambda flows along with dead letter queue, circuit breaker pattern, & idempotent code to achieve fault tolerance & self-healing data operations around multiple 3rd party systems API integrations.",
                "Designed and optimized NoSQL database schemas in DynamoDB, achieving single-digit millisecond latency for highly scalable and efficient data queries.",
                "Optimized web page load by implementing web file compression (Brotli) on webpack build & Java Spring Boot level to reduce page loading speed from 10 sec to 1-2 sec",
                "Developed and maintained reusable, WCAG-compliant components with ReactJS, enhancing user experience and accessibility along with micro-frontend for different user persona.",
                "Implemented Redux toolkit for complex state management on ReactJS and the Jest framework to write integration testing for ReactJS components.",
                "Engineered high-performance APIs and robust batch processing jobs with Java Spring Boot for critical data operations & report generation.",
                "Implemented AWS Lambda snapstart to reduce boot-up time from 15s to 1s.",
                "Automated and streamlined ETL pipelines using AWS Glue and Python with Spark, improving data processing efficiency by 70% and reducing manual oversight from SRE."
            ]
        },
        {
            company: "J.P. Morgan",
            role: "Full-time",
            project: "MyTimesheet",
            duration: "Jan 2022 – Oct 2023",
            location: "Bengaluru",
            description: "Handles APAC & LATAM employee time, salary & rewards like pension, stocks",
            points: [
                "Design and implementation of a multi-region AWS web app running with EKS, Aurora PostgreSQL, and Lambda, & provisioned associated infrastructure using IAC (Terraform)",
                "Built a configurable web app with Admin UI to onboard new countries, define rules, and add validations. Reduced country onboarding time from 3-6 months to 3 weeks.",
                "Implemented the end-to-end architecture and development of a full-stack microservices application from inception to production deployment.",
                "Engineered responsive and mobile-first user interfaces with ReactJS, focusing on reusable component development and optimal UI/UX.",
                "Optimized APIs (Java Spring Boot) with a Cache-aside strategy for database data load to reduce time spent on costly calculations within methods. Significantly enhancing application performance and scalability by reducing response time from >1s to <200ms on average.",
                "Deployed and managed core application infrastructure on AWS (ALB, EKS, Aurora PostgreSQL) through Terraform, ensuring robust and scalable environments.",
                "Implemented Python-based AWS Lambda functions for efficient user notifications and quick data processing."
            ]
        },
        {
            company: "J.P. Morgan",
            role: "Full-time",
            project: "Time & Pay Systems",
            duration: "Aug 2020 – Dec 2021",
            location: "Bengaluru",
            points: [
                "Developed and maintained front-end features for web applications, including crafting reusable components with ReactJS and JavaScript.",
                "Developed and enhanced backend functionalities using Java Spring Boot for various business requirements.",
                "Optimized Oracle database queries and procedures (PL/SQL) to improve application performance and data retrieval efficiency.",
                "Leveraged SQL and Shell scripting for data manipulation and automation; managed CI/CD pipelines to support continuous integration and deployment."
            ]
        },
        {
            company: "J.P. Morgan",
            role: "Internship",
            project: "Investment Trading Data",
            duration: "Jan 2020 – Jul 2020",
            location: "Bengaluru",
            points: [
                "Gained foundational knowledge in SQL, data processing, analysis, and automation for investment transactions & audits as a Data Analyst Intern."
            ]
        },
        {
            company: "EngagePulse",
            role: "Part-time",
            project: "InFlow",
            duration: "Aug 2019 – Dec 2019",
            location: "Remote",
            description: "Employee onboarding & engagement platform",
            points: [
                "Built initial MVP for the EngagePulse platform using ReactJS for front-end and NodeJS for back-end services.",
                "Implemented RESTful APIs and integrated third-party services to enhance platform functionality.",
                "AWS DynamoDB was used for storing user data and application state."
            ]
        },
    ],
    projects: [
        {
            name: "Pennywise",
            description: "Developed an open-source data privacy-focused web app to track expenses via Bank email notifications. Google Cloud functions, Firestore (NoSQL database), App Script, Firebase Hosting, Google Auth, and used IndexedDB for local device cache.",
            link: "https://github.com/rushikc/pennywise",
            tech: ["Google Cloud Functions", "Gmail API" ,"Firestore", "App Script", "Firebase Hosting", "Google Auth", "IndexedDB"]
        },
        {
            name: "Firebase Gmail Kickstart",
            description: "A Firebase Gmail Kickstart project. This boilerplate demonstrates building a full-stack application on Google Cloud. It uses Google Apps Script to parse Gmail messages and Cloud Functions to save the data in Firestore. The project features a React frontend with offline support and Google OAuth for user authentication.",
            link: "https://github.com/rushikc/firebase-gmail-kickstart",
            tech: ["Google Cloud Functions", "Gmail API" ,"Firestore", "App Script", "Firebase Hosting", "Google Auth", "IndexedDB"]
        },
        {
            name: "AWS DeepRacer",
            description: "AWS DeepRacer | Ross Raceway Model A reinforcement learning model trained for the Ross Raceway track using AWS DeepRacer.",
            link: "https://github.com/rushikc/aws-deepracer",
            tech: ["AWS", "Python"]
        },
        {
            name: "Reel Composer (Contributor)",
            description: "Reel Composer is a \"Director's Studio\" that transforms raw talking-head footage into high-retention \"Edutainment\" content (Instagram Reels / TikToks / YouTube Shorts).",
            link: "https://github.com/prasannathapa/reel-composer",
            tech: ["React", "Gemini AI", "Typescript"]
        }
    ],
    certifications: [
        {
            name: "AWS Certified Solutions Architect",
            issuer: "Amazon Web Services",
            date: "Apr 2025",
            link: "https://www.credly.com/badges/531a2ba6-0263-4741-9db4-a5d8242d8b70/public_url"
        },
        {
            name: "HashiCorp Certified - Terraform Associate",
            issuer: "HashiCorp",
            date: "Oct 2024",
            link: "https://www.credly.com/badges/fc4a00a9-a429-492c-99b3-05060dd381e0/public_url"
        }
    ],
    awards: [
        "AEROTHON 2.0 Hackathon by Airbus - Winner",
        "AWS DeepRacer JPMC - Top 7th team in Bengaluru"
    ],
    education: {
        institution: "Ramaiah Institute Of Technology",
        location: "Bengaluru",
        degree: "BE Computer Science",
        duration: "2016 – 2020",
        gpa: "8.3 CGPA"
    }
};

